module.exports = __webpack_public_path__ + "static/media/Health.5eccad65.svg";